import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./Search.css";
import SearchBox from "../../components/Search";
import api from "../../services/baseUrl";
import CircularProgress from "@mui/material/CircularProgress";
import HighlightedText from "../../components/HighlightKeyword";
import { useLibrary } from "../../context/LibraryContext";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowUnsorted,
} from "react-icons/ti";
import Pagination from "../../components/Pagination";

export default function Search() {
  const { libraryId, keyword } = useLibrary();
  const [documentList, setDocumentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [defaultView, setDefaultView] = useState(true);
  const [totalResult, setTotalResult] = useState(0);
  const navigate = useNavigate();
  const [documentName, setDocumentName] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [searchParams, setSearchParams] = useSearchParams();

  let globalPayload = Object.fromEntries(params.entries());

  // 2. If no query params, fallback to state
  if (!Object.keys(globalPayload).length && location.state?.globalPayload) {
    globalPayload = location.state.globalPayload;
  }
  // const globalPayload = location.state?.globalPayload;
  // const offset = Number(globalPayload.offset || 0);
  const [library, setLibrary] = useState(null);
  const [allowMeta, setAllowMeta] = useState(true);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const limitParam = Number(searchParams.get("limit")) || 10;
  const pageParam = Number(searchParams.get("page")) || 0;

  const [limit, setLimit] = useState(limitParam ? Number(limitParam) : 10);
  const [currentPage, setCurrentPage] = useState(
    pageParam ? Number(pageParam) - 1 : 0
  );
const [itemOffset, setItemOffset] = useState(
  Math.max((pageParam - 1) * limit, 0)
);  const [pageCount, setPageCount] = useState(0);
  const [currentItems, setCurrentItems] = useState([]);
  // const [itemOffset, setItemOffset] = useState(0);

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedList = [...documentList].sort((a, b) => {
      const aValue = a[key]?.toLowerCase() || "";
      const bValue = b[key]?.toLowerCase() || "";

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setDocumentList(sortedList);
    setSortConfig({ key, direction });
    setItemOffset(0);
    setCurrentPage(0);
  };

  const getArrowIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? (
        <TiArrowSortedUp size={18} className="case-law-arrow-up" />
      ) : (
        <TiArrowSortedDown size={18} className="case-law-arrow-down" />
      );
    } else {
      return <TiArrowUnsorted size={18} />;
    }
  };

  // const handlePageClick = (event) => {
  //   const newOffset = (event.selected * limit) % documentList.length;
  //   setItemOffset(newOffset);

  //   const syariahBody = document.querySelector(".law-library-search-body");
  //   if (syariahBody) {
  //     const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
  //     window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
  //   }
  //   setCurrentPage(event.selected);
  // };

  // const handlePageClick = (event) => {
  //   const newPage = event.selected;
  //   const newOffset = (newPage * limit) % documentList.length;

  //   setItemOffset(newOffset);
  //   setCurrentPage(newPage);

  //   // update query params
  //   setSearchParams((prev) => {
  //     const params = new URLSearchParams(prev);
  //     params.set("page", newPage);
  //     params.set("limit", limit);
  //     return params;
  //   });

  //   const syariahBody = document.querySelector(".law-library-search-body");
  //   if (syariahBody) {
  //     const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
  //     window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
  //   }
  // };

  const handlePageClick = (event) => {
    const selectedPage = event.selected; // UI shows 1,2,3...
    setCurrentPage(selectedPage);

    const newOffset = (selectedPage * limit) % documentList.length;
    setItemOffset(newOffset);

    // update URL with zero-based page
    const params = new URLSearchParams(location.search);
    params.set("page", selectedPage + 1);
    params.set("limit", limit);
    navigate(`${location.pathname}?${params.toString()}`);

    // smooth scroll
    const syariahBody = document.querySelector(".law-library-search-body");
    if (syariahBody) {
      const bodyTop = syariahBody.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: bodyTop - 75, behavior: "smooth" });
    }
  };

  useEffect(() => {
    console.log(documentList);
    
    if (documentList) {
      const endOffset = itemOffset + limit;
      setCurrentItems(documentList.slice(itemOffset, endOffset));
      console.log(itemOffset);
      
      setPageCount(Math.ceil(documentList.length / limit));
      setTotalResult(documentList.length);
    }
  }, [itemOffset, limit, documentList]);

  // useEffect(() => {
  //   if (documentList) {
  //     const endOffset = offset + limit;
  //     setCurrentItems(documentList.slice(offset, endOffset));
  //     setPageCount(Math.ceil(documentList.length / limit));
  //     setTotalResult(documentList.length);
  //   }
  // }, [offset, limit, documentList]);

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(0); // reset to first page
    setItemOffset(0);

    // update query params
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("limit", newLimit);
      params.set("page", 0);
      return params;
    });
  };

  useEffect(() => {
    setLoading(true);

    // Parse query params only
    const params = new URLSearchParams(location.search);
    const payload = Object.fromEntries(params.entries());

    if (payload.query !== undefined) {
      
      // Convert numbers back
      payload.limit = Number(payload.limit || 10);
      payload.offset = Number(payload.offset || 0);
      payload.library = Number(payload.library);

      if (payload.documentName !== undefined) {
        setAllowMeta(false);
      }
      setDocumentName(payload.documentName);
      setQuery(payload.query);

      const handleSearch = async () => {
        setLoading(true);
        try {
          if (payload.type === "content") {
            
            setDefaultView(false);
            const response = await api.post(
              "/search/cont/law-library",
              payload,
              {
                headers: { "Content-Type": "application/json" },
              }
            );
            if (response.status === 200) {
              setDocumentList(response.data.results);
              setTotalResult(response.data.results.length);
              
            } else {
              console.error("Search failed:", response.statusText);
            }
          } else {
            setDefaultView(true);
            const response = await api.post(
              "/search/meta/law-library",
              payload,
              {
                headers: { "Content-Type": "application/json" },
              }
            );
            if (response.status === 200) {
              setDocumentList(response.data || []);
              setTotalResult(response.data.length);
            } else {
              console.error("Search failed:", response.statusText);
            }
          }
        } catch (error) {
          console.error("An error occurred:", error);
        } finally {
          setLoading(false);
        }
      };

      handleSearch();
    } else if (payload.library !== undefined) {
            payload.library = Number(payload.library);
            setDefaultView(true);
      const fetchData = async () => {
        try {
          const response = await api.post("/law-library/default", {
            libraryId: payload.library,
            attribute: payload.attribute
          });
          setDocumentList(response.data);
          setTotalResult(response.data.length);
          setLoading(false);
        } catch (err) {}
      };

      const fetchLibrary = async () => {
        try {
          const response = await api.get("/library", {
            params: { libraryId: payload.library },
          });
          setLibrary(response.data);
        } catch (err) {}
      };

      fetchData();
      fetchLibrary();
    } else {
      setLoading(false);
    }
  }, [libraryId, location.search]);

 const defaultSearch = (libraryId, limit, offset, attribute) => {
   const newPayload = {
     library: libraryId,
     limit,
     offset,
     ...(attribute && { attribute }),
   };

   const queryString = new URLSearchParams(newPayload).toString();
   navigate(`/law-library/search?${queryString}`);
 };

  const handleGlobalSearch = (keyword) => {
    console.log("In Global");

    // Build payload
    let payload = { ...globalPayload }; // or build from scratch if you want
    if (keyword === "keyword") {
      payload.type = "content";
    } else {
      payload.type = keyword.toLowerCase();
    }

    // Convert to query string
    const queryString = new URLSearchParams(payload).toString();
    console.log(queryString);

    // Navigate with query params
    navigate(`/law-library/search?${queryString}`);
  };
  const handleSearch = ({
    searchQuery = "",
    limit = 10,
    keyword,
    offset = 0,
    library = libraryId,
    attribute,
  }) => {
    if (!searchQuery) {
      defaultSearch(library, limit, offset, attribute);
      return;
    }
    if (!library) {
      globalPayload.offset = offset;
      globalPayload.query = searchQuery;
      globalPayload.limit = limit;
      handleGlobalSearch(keyword);
      return;
    }

    setLoading(true);
    setQuery(searchQuery);

    const isKeywordSearch = keyword === "keyword";

    const newPayload = {
      query: searchQuery,
      type: isKeywordSearch ? "content" : keyword?.toLowerCase(),
      limit,
      offset,
      library,
      ...(attribute && { attribute }),
      ...(isKeywordSearch && { modules: "lawlibrary", search: "keyword" }),
    };

    // Update URL with query params
    const queryString = new URLSearchParams(newPayload).toString();
    navigate(`/law-library/search?${queryString}`);
  };
  // const handleGlobalSearch = async (keyword) => {
  //   setLoading(true);
  //   if (keyword === "keyword") {
  //     globalPayload.type = "content";
  //   } else {
  //     globalPayload.type = keyword.toLowerCase();
  //   }
  //   if (globalPayload.type === "content") {
  //     setDefaultView(false);
  //     try {
  //       const response = await api.post(
  //         "/search/cont/law-library",
  //         globalPayload,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (response.status === 200) {
  //         setDocumentList(response.data.results || []);
  //       } else {
  //         console.error("Search failed:", response.statusText);
  //       }
  //     } catch (error) {
  //       console.error("An error occurred:", error);
  //     } finally {
  //       setLoading(false); // Set loading to false when search completes
  //     }
  //   } else {
  //     setDefaultView(true);
  //     try {
  //       const response = await api.post(
  //         "/search/meta/law-library",
  //         globalPayload,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (response.status === 200) {
  //         setDocumentList(response.data || []);
  //         setTotalResult(response.data.length);
  //       } else {
  //         console.error("Search failed:", response.statusText);
  //       }
  //     } catch (error) {
  //       console.error("An error occurred:", error);
  //     } finally {
  //       setLoading(false); // Set loading to false when search completes
  //     }
  //   }
  // };
  // const handleSearch = async ({
  //   searchQuery = "",
  //   limit = 10,
  //   keyword,
  //   offset = 0,
  //   library = libraryId,
  //   attribute,
  // }) => {
  //   if (!searchQuery) {
  //     defaultSearch(library, limit, offset);
  //     return;
  //   }

  //   setLoading(true);
  //   setQuery(searchQuery);

  //   let newPayload = {};

  //   if (globalPayload) {
  //     if (!globalPayload.library) {
  //       globalPayload.offset = offset;
  //       globalPayload.query = searchQuery;
  //       globalPayload.limit = limit;
  //       handleGlobalSearch(keyword);
  //       return;
  //     }
  //   }
  //   if (documentName) {
  //     setAllowMeta(false);
  //     newPayload = {
  //       ...globalPayload,
  //       query: searchQuery,
  //       limit,
  //     };

  //     const endpoint =
  //       newPayload.type === "content"
  //         ? "/search/cont/law-library"
  //         : "/search/meta/law-library";

  //     setDefaultView(newPayload.type !== "content");

  //     try {
  //       const response = await api.post(endpoint, newPayload, {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       });
  //       if (response.status === 200) {
  //         if (newPayload.type === "content") {
  //           setDocumentList(response.data.results || []);
  //         } else {
  //           setDocumentList(response.data || []);
  //           setTotalResult(response.data.length);
  //         }
  //       } else {
  //         console.error("Search failed:", response.statusText);
  //       }
  //     } catch (error) {
  //       console.error("An error occurred:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   } else {
  //     const isKeywordSearch = keyword === "keyword";

  //     setDefaultView(!isKeywordSearch);
  //     setDocumentList(isKeywordSearch ? null : []);

  //     newPayload = {
  //       query: searchQuery,
  //       type: isKeywordSearch ? "content" : keyword,
  //       modules: isKeywordSearch ? "lawlibrary" : undefined,
  //       search: isKeywordSearch ? "keyword" : undefined,
  //       library,
  //       ...(attribute && { attribute }),
  //     };

  //     const endpoint = isKeywordSearch
  //       ? "/search/cont/law-library"
  //       : "/search/meta/law-library";

  //     try {
  //       const response = await api.post(endpoint, newPayload, {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       });
  //       if (response.status === 200) {
  //         if (isKeywordSearch) {
  //           setDocumentList(response.data.results);
  //         } else {
  //           setDocumentList(response.data);
  //           setTotalResult(response.data.length);
  //         }
  //       } else {
  //         console.error("Search failed:", response.statusText);
  //       }
  //     } catch (error) {
  //       console.error("An error occurred:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // };

  const renderBreadcrumbs = () => {
    if (
      globalPayload &&
      (globalPayload.library === undefined || globalPayload.library === null)
    ) {
      return (
        <div style={{ paddingTop: "25px", paddingLeft: "25px" }}>
          Law-Library &gt; All
        </div>
      );
    } else if (documentName != null) {
      return (
        <div style={{ paddingTop: "25px", paddingLeft: "25px" }}>
          Law-Library &gt; Result(s) from: {documentName}
        </div>
      );
    } else if (library) {
      return (
        <div style={{ paddingTop: "25px", paddingLeft: "25px" }}>
          Law-Library &gt; {library.name}
        </div>
      );
    }
  };

  return (
    <>
      <div className="law-library-search-body">
        {renderBreadcrumbs()}
        <div style={{ padding: "0 25px" }}>
          <SearchBox
            ready={allowMeta}
            onSearch={handleSearch}
            placeholder={"Enter keyword to search"}
            query={query}
            libraryId={libraryId}
            limit={limit}
            setLimit={setLimit}
          />
        </div>
        {defaultView ? (
          <div>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 40,
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <table className="content case-law-table">
                <thead>
                  <tr>
                    <th
                      style={{ minWidth: "5vw" }}
                      onClick={() => handleSort("year")}
                    >
                      <div className="case-law-table-header">
                        Year {getArrowIcon("year")}
                      </div>
                    </th>
                    <th
                      style={{ minWidth: "10vw" }}
                      onClick={() => handleSort("no")}
                    >
                      <div className="case-law-table-header">
                        Act No {getArrowIcon("no")}
                      </div>
                    </th>
                    <th
                      style={{ minWidth: "15vw" }}
                      onClick={() => handleSort("title")}
                    >
                      <div className="case-law-table-header">
                        Title {getArrowIcon("title")}
                      </div>
                    </th>
                    {keyword === "Category" ? <th
                      style={{ minWidth: "15vw" }}
                      onClick={() => handleSort("catrgory")}
                    >
                      <div className="case-law-table-header">
                        Category {getArrowIcon("catrgory")}
                      </div>
                    </th> : ("")}
                    <th
                      style={{ minWidth: "15vw" }}
                      onClick={() => handleSort("publishDate")}
                    >
                      <div className="case-law-table-header">
                        Published Date {getArrowIcon("publishDate")}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((result, index) => (
                    <tr key={index}>
                      <td>{result.year}</td>
                      <td className="egazette-file-title">
                        <p
                          onClick={() => {
                            navigate(
                              `/law-library/document?documentID=${result.documentID}`
                            );
                          }}
                        >
                          {result.no}
                        </p>
                      </td>
                      <td className="egazette-file-title">
                        <p>
                          <HighlightedText
                            paragraph={result.title}
                            keyword={query}
                            onClick={() =>
                              navigate(
                                `/law-library/document?documentID=${result.documentID}`
                              )
                            }
                          />
                        </p>
                      </td>
                      {keyword === "Category" ? <td>{result.classificationId}</td> : ("")}
                      <td style={{ textAlign: "center" }}>
                        {result.publishDate
                          ? new Date(result.publishDate).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              }
                            )
                          : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        ) : loading ? (
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 40 }}
          >
            <CircularProgress />
          </div>
        ) : documentList.length > 0 ? (
          <div className="content">
            <table className="case-law-table">
              <thead>
                <tr>
                  <th style={{ minWidth: "5vw" }}>
                    <div className="case-law-table-header">Year</div>
                  </th>
                  <th style={{ minWidth: "5vw" }}>
                    <div className="case-law-table-header">Act No</div>
                  </th>
                  <th style={{ maxWidth: "8vw" }}>
                    <div className="case-law-table-header">Title</div>
                  </th>
                  <th style={{ maxWidth: "8vw" }}>
                    <div className="case-law-table-header">Section Title</div>
                  </th>
                  <th style={{ minWidth: "15vw" }}>
                    <div className="case-law-table-header">Text</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((result, index) => (
                  <tr key={index}>
                    <td>{result?.metadata?.[0]?.year}</td>
                    <td>{result?.metadata?.[0]?.no}</td>
                    <td>
                      <div>
                        <HighlightedText
                          paragraph={result.title}
                          keyword={query}
                        />
                      </div>
                    </td>
                    <td colSpan={2}>
                      {result?.chunks?.map((chunk, chunkIndex) => (
                        <div
                          key={chunkIndex}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "25% 5% 70%",
                            alignItems: "start",
                            marginBottom: "10px",
                          }}
                        >
                          <span
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <HighlightedText
                              paragraph={chunk.section_title}
                              keyword={query}
                              onClick={() =>
                                navigate(
                                  `/law-library/document?subdocumentId=${chunk.sub_document_ID}`
                                )
                              }
                            />{" "}
                          </span>
                          <div></div>
                          <HighlightedText
                            paragraph={chunk.relevant_excerpt}
                            keyword={query}
                            onClick={() =>
                              navigate(
                                `/law-library/document?subdocumentId=${chunk.sub_document_ID}`
                              )
                            }
                          />
                        </div>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ margin: "25px" }}>No results found</div>
        )}
      </div>

      {defaultView && (
        <Pagination
          handlePageClick={handlePageClick}
          pageCount={pageCount}
          currentPageNumber={currentPage}
          totalResult={totalResult}
          limit={limit}
          offset={itemOffset}
        />
      )}
    </>
  );
}
